import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Whether rideshare calling is enabled (HopDrive Lite only).
 */
export const schema = z.boolean();

export type RideshareCallingEnabled = z.infer<typeof schema>;

export const definition = define({
  key: 'rideshare_calling_enabled',
  schema,
  label: 'Rideshare Calling Enabled',
  description:
    'Hopdrive Lite only. This setting will determine whether Lite clients at this level have opted to enable calling rideshares for their drivers.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.RIDESHARE.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
